export default __webpack_public_path__ + "static/media/47.48453973.jpg";